export enum FaqEnums {
  users = 'Korisnici',
  user = 'Korisnik',
  userForDB = 'user',
  businessUsers = 'Biznis korisnici',
  businessUser = 'Biznis korisnik',
  businessUserForDB = 'business',
}
